export const WIDGET_REGISTRY_PROP = 'widgetRegistry';

export const ACTIVE_DASHBOARD_SECTION_ID = 'active-dashboard-section';
export const ACTIVE_DASHBOARD_SECTION_BM_COMPONENT = 'active-dashboard-section-component';

export const COLUMN_1_ID = '721bea57-351a-4cce-a796-3958f0983d7f';
export const COLUMN_2_ID = 'd6c81500-a577-4fef-9796-0253a987d364';
export const DASHBOARD_DEALER_COLUMNS = [COLUMN_1_ID, COLUMN_2_ID];
export const DEALER_PERSONALIZED_DEFAULT_LAYOUT = '2e68cdf1-e06e-4947-be89-1b76496e1217';
export const DEALER_WIDGETS_DEFINITIONS = '14562ec1-c53f-480e-9e92-6a7ebd36d4e7';
export const DEALER_CUSTOMIZABLE_WIDGETS = '8dce5458-f032-41df-89a6-69bd0ea84038';

export const DEALER_SERVICE_URL = '/_api/dealer-offers-serving-service';

export const MODALS_COMPONENT_NAME = 'business-dashboard-modals';

export const DASHBOARD_WIDGETS_PANEL_COMPONENT_NAME = 'dashboard-widgets-panel';

export const DASHBOARD_SALES_BANNER_COMPONENT_NAME = 'dashboard-sales-banner';
export const DASHBOARD_SALES_BANNER_WIDGET_ID = 'dashboard-sales-banner';

export const DH_HOME_ROOT = 'business-dashboard-root';
export const DH_ACTIVE_DASHBOARD_CONTAINER = 'active-dashboard-container';

export const DASHBOARD_MAIN_PAGE = 'business-dashboard-app.pages.index';

export const WIDGET_COMPONENT_DATA_HOOK = 'widget-component-data-hook';

export const fedopsPhases = {
  LOAD_DEALER_LAYOUT: 'fetch-dealer-layout',
  LOAD_DASHBOARD_PAGE: 'load-dashboard-page',
  LOAD_FIRST_INTERACTIVE_WIDGETS: 'load-first-interactive-widgets',
  LOAD_REST_OF_WIDGETS: 'load-rest-of-widgets',
};

export const fedopsInteractions = {
  LOAD_CUSTOMIZATION_WIDGETS_PANEL: 'customization-widgets-panel-load',
  CUSTOMIZATION_ADD_WIDGET_SAVE: 'customization-add-widget-save',
  CUSTOMIZATION_REMOVE_WIDGET_SAVE: 'customization-remove-widget-save',
};

export const ENABLE_DASHBOARD_CUSTOMIZATION_SPEC = 'specs.wos1.enableDashboardCustomization';

export const DRAGGABLE_DATA_HOOK = 'draggable-data-hook';
export const DRAGGABLE_WRAPPER_DATA_HOOK = 'draggable-wrapper-data-hook';
export const CUSTOMIZE_DASHBOARD_PERMISSION = 'DASHBOARD.CUSTOMIZE';
